
const state = {
  areaList: [],
  infoObj: {},
  downProgress: 0
}

const mutations = {
  SET_AREALIST: (state, areaList = []) => {
    state.areaList = areaList
  },
  SET_DOWNPROGRESS: (state, downProgress) => {
    state.downProgress = downProgress
  },
  SET_INFO_OBJ: (state, infoObj = {}) => {
    state.infoObj = infoObj
  }
}

const actions = {
  setAreaList({ commit }, areaList) {
    commit('SET_AREALIST', areaList)
  },
  setDownProgress({ commit }, downProgress) {
    commit('SET_DOWNPROGRESS', downProgress || 0)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
